import React, { createContext, useContext, useEffect, useState } from 'react';

type RtlContextType = {
  isRtl: boolean;
  toggleDirection: () => void;
};

const RtlContext = createContext<RtlContextType>({
  isRtl: false,
  toggleDirection: () => {},
});

export const useRtl = () => useContext(RtlContext);

type RtlProviderProps = {
  children: React.ReactNode;
  defaultDirection?: 'rtl' | 'ltr';
};

export const RtlProvider: React.FC<RtlProviderProps> = ({
  children,
  defaultDirection = 'rtl',
}) => {
  const [isRtl, setIsRtl] = useState(defaultDirection === 'rtl');

  useEffect(() => {
    // Set the direction on the html element
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';

    if (isRtl) {
      document.documentElement.classList.add('rtl');
      document.documentElement.classList.remove('ltr');
    } else {
      document.documentElement.classList.add('ltr');
      document.documentElement.classList.remove('rtl');
    }
  }, [isRtl]);

  const toggleDirection = () => {
    setIsRtl((prev) => !prev);
  };

  return (
    <RtlContext.Provider value={{ isRtl, toggleDirection }}>
      {children}
    </RtlContext.Provider>
  );
};
